/* eslint-disable import/no-anonymous-default-export */
export default {
	styleOverrides: {
		root: {
			minHeight: 30,
			minWidth: '30%',
			margin: '0em',
			paddingTop: '2.5em',
			textAlign: 'left',
		},
		indicator: {
			backgroundColor: 'transparent',
		},
	},
};
